/**
 * 특정 서비스 이름에 줄바꿈(\n)을 삽입하는 헬퍼 함수.
 * white-space: pre-line이 적용된 영역에서 사용.
 *
 * API에서 줄바꿈 정보를 제공할 수 없어 서비스 keyword prefix 기반으로 처리.
 */

/**
 * keyword prefix → 줄바꿈 삽입 위치(breakAfter 단어 뒤)를 정의하는 규칙 목록.
 * 배열 순서대로 매칭하며, 먼저 매칭된 규칙이 적용됨.
 */
const LINE_BREAK_PREFIX_RULES: ReadonlyArray<{ breakAfter: string; keywordPrefix: string }> = [
  { keywordPrefix: 'beyond-', breakAfter: 'Beyond' },
  { keywordPrefix: 'advanced-managed-', breakAfter: 'Advanced' },
  { keywordPrefix: 'alert-center-for-', breakAfter: 'Alert Center' },
];

export function getServiceDisplayName(serviceKeyword: string, serviceName: string): string {
  const rule = LINE_BREAK_PREFIX_RULES.find(({ keywordPrefix }) =>
    serviceKeyword.startsWith(keywordPrefix),
  );
  if (!rule) return serviceName;

  // 해당 문자열 바로 뒤에 줄바꿈 삽입 (첫 번째 매칭만 치환 — 의도적 설계)
  return serviceName.replace(`${rule.breakAfter} `, `${rule.breakAfter}\n`);
}
